module.exports = __webpack_public_path__ + "img/gentlemen-club-collection-12.97e31680.png";